import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../webcomponents.constants';
import { EasmAssetsInventoryGridViewDataProvider } from '../dataProvider/EasmAssetsInventoryViewDataProvider';

export class EasmAssetsInventoryDataProviderFactory extends BaseWebComponentDataProviderFactory {
  public constructor() {
    super();

    this.map.set(API_TYPE_GZ, EasmAssetsInventoryGridViewDataProvider);
  }
}
